// Shared page header for authenticated pages.
// Title, one-line subtitle, optional right-side actions and meta strip.

import type { ReactNode } from "react";

export function PageHeader({
  title,
  subtitle,
  actions,
  meta,
}: {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
  meta?: ReactNode;
}) {
  return (
    <header className="flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between">
      <div className="min-w-[16rem] flex-1">
        <h1 className="font-display text-3xl font-semibold tracking-tight text-ink">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1 max-w-2xl text-base text-muted-foreground">{subtitle}</p>
        )}
        {meta && <div className="mt-3 flex flex-wrap items-center gap-2">{meta}</div>}
      </div>
      {actions && <div className="flex min-w-0 flex-wrap items-center gap-2 xl:max-w-[65%] xl:justify-end">{actions}</div>}
    </header>
  );
}
